
import Vue from 'vue'
import Router from 'vue-router'

// Stores
import store from '@/stores'

// Components
import PageNotFound from '@/components/PageNotFound'
import Login from '@/views/session/Login'
import Register from '@/views/session/Register'
import Verify from '@/views/session/Verify'
import Error404 from '@/views/errors/404'
import Error500 from '@/views/errors/500'
import Dashboard from '@/Dashboard'
import ForgotPW from "@/views/session/ForgotPW";


// Routes
import DashboardRoutes from '@/router/dashboard'

Vue.use(Router)

let router = new Router({
  // mode: 'history',zz
  routes: [
    {
      path: '/',
      meta: { auth: false },
      redirect: '/dashboard'
    },{
      path: '/connexion',
      name: 'login',
      meta: { auth: false },
      component: Login
    },{
      path: '/inscription',
      name: 'register',
      meta: { auth: false },
      component: Register
    },{
      path: '/verifier',
      name: 'verify',
      meta: { auth: false },
      component: Verify
    },{
      path: '/dashboard',
      component: Dashboard,
      children: DashboardRoutes,
      meta: { auth: true }
    },
    {
      path: '/forgotPW',
      name: 'forgotPW',
      meta: { auth: false },
      component: ForgotPW
    },
    { path: "/500", component: Error500,  meta: { auth: false }},
    { path: "/404", component: Error404, meta: { auth: false } },
    { path: "*", component: Error404, meta: { auth: false } }
  ]
})

router.onError((error)=> {
  // console.log(router.push('/500'));
  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if(error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  // window.location.href = "/static/500.html";

})

let checkDevices = () => {
  store.dispatch('devicesStore/devices').then((response) => {
    if (response.data && response.data.length > 0) {
      return Promise.resolve()
    } else {
      return Promise.reject()
    }
  })
}

router.beforeEach(function (to, from, next) {
  if (to.meta.auth && store.state.sessionStore.authToken == '' && store.state.sessionStore.idToken == '') {
    // If auth if required and state keys are empty, we check in local storage
    store.dispatch('sessionStore/checkLocalStorageForKeys')
    .then(next)
    .catch(()=>{next({ path: '/connexion'} )})
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js